import React from "react";
import { CircularProgress } from "@mui/material";
import SelectAutoCompleteMultiple from "components/SelectAutoCompleteMultipleG";

interface Option {
  label: string;
  value: string;
}

interface Props {
  checkedCount: number;
  isLoading: boolean;
  empreendimentos: any;
  selectedProdutos: Option[];
  onSelectedProdutosChange: (value: Option[]) => void;
  onCancel: () => void;
  onApply: () => void;
}

export const ProdutosMultipleContent: React.FC<Props> = ({
  checkedCount,
  isLoading,
  empreendimentos,
  selectedProdutos,
  onSelectedProdutosChange,
  onCancel,
  onApply,
}) => (
  <div
    style={{
      padding: "28px",
      maxHeight: "550px",
      overflowY: "auto",
      fontFamily:
        "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
      position: "relative",
    }}
  >
    {isLoading && (
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000,
          borderRadius: "8px",
          backdropFilter: "blur(2px)",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <CircularProgress size={40} style={{ color: "#2D5BFF" }} />
          <p
            style={{
              fontSize: "14px",
              color: "#6B7280",
              fontWeight: 500,
              margin: 0,
              fontFamily: "inherit",
            }}
          >
            Aplicando produtos...
          </p>
        </div>
      </div>
    )}

    <div
      style={{
        marginBottom: "28px",
        paddingBottom: "20px",
        borderBottom: "2px solid #F3F4F6",
      }}
    >
      <h2
        style={{
          fontSize: "20px",
          fontWeight: 700,
          color: "#111827",
          marginBottom: "10px",
          marginTop: 0,
          fontFamily: "inherit",
          letterSpacing: "-0.02em",
        }}
      >
        Alterar Produtos
      </h2>
      <p
        style={{
          fontSize: "15px",
          color: "#6B7280",
          margin: 0,
          fontFamily: "inherit",
          fontWeight: 400,
        }}
      >
        {checkedCount} lead{checkedCount !== 1 ? "s" : ""} selecionado
        {checkedCount !== 1 ? "s" : ""}
      </p>
    </div>

    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <SelectAutoCompleteMultiple
        borderRadius="8px"
        data={
          empreendimentos?.data?.map((emp: any) => ({
            value: emp.id,
            label: emp.nome,
          })) || []
        }
        placeholder="Selecione os produtos"
        label="Produtos"
        value={selectedProdutos}
        disabled={isLoading}
        onChange={(_event: any, newValue: Option[] | null) =>
          onSelectedProdutosChange(newValue || [])
        }
      />

      {selectedProdutos.length > 0 && (
        <div
          style={{
            padding: "12px 16px",
            backgroundColor: "#EFF6FF",
            borderRadius: "8px",
            border: "1px solid #DBEAFE",
          }}
        >
          <p
            style={{
              fontSize: "13px",
              color: "#1E40AF",
              margin: 0,
              fontFamily: "inherit",
              fontWeight: 500,
            }}
          >
            {`${selectedProdutos.length} produto${
              selectedProdutos.length !== 1 ? "s" : ""
            } selecionado${selectedProdutos.length !== 1 ? "s" : ""}`}
          </p>
        </div>
      )}

      <div
        style={{
          display: "flex",
          gap: "12px",
          marginTop: "24px",
          paddingTop: "20px",
          borderTop: "1px solid #E5E7EB",
        }}
      >
        <button
          type="button"
          onClick={onCancel}
          disabled={isLoading}
          style={{
            flex: 1,
            padding: "12px 24px",
            fontSize: "15px",
            fontWeight: 600,
            fontFamily: "inherit",
            borderRadius: "8px",
            border: "1.5px solid #D0D5DD",
            backgroundColor: "#FFFFFF",
            color: "#374151",
            cursor: isLoading ? "not-allowed" : "pointer",
            transition: "all 0.2s ease",
            opacity: isLoading ? 0.6 : 1,
          }}
          onMouseEnter={(e) => {
            if (!isLoading) {
              e.currentTarget.style.backgroundColor = "#F9FAFB";
              e.currentTarget.style.borderColor = "#9CA3AF";
            }
          }}
          onMouseLeave={(e) => {
            if (!isLoading) {
              e.currentTarget.style.backgroundColor = "#FFFFFF";
              e.currentTarget.style.borderColor = "#D0D5DD";
            }
          }}
        >
          Cancelar
        </button>
        <button
          type="button"
          onClick={onApply}
          disabled={isLoading || selectedProdutos.length === 0}
          style={{
            flex: 1,
            padding: "12px 24px",
            fontSize: "15px",
            fontWeight: 600,
            fontFamily: "inherit",
            borderRadius: "8px",
            border: "none",
            backgroundColor:
              selectedProdutos.length === 0 || isLoading
                ? "#9CA3AF"
                : "#2D5BFF",
            color: "#FFFFFF",
            cursor:
              selectedProdutos.length === 0 || isLoading
                ? "not-allowed"
                : "pointer",
            transition: "all 0.2s ease",
            opacity: isLoading || selectedProdutos.length === 0 ? 0.6 : 1,
          }}
          onMouseEnter={(e) => {
            if (!isLoading && selectedProdutos.length > 0)
              e.currentTarget.style.backgroundColor = "#1E40AF";
          }}
          onMouseLeave={(e) => {
            if (!isLoading && selectedProdutos.length > 0)
              e.currentTarget.style.backgroundColor = "#2D5BFF";
          }}
        >
          {isLoading ? "Aplicando..." : "Aplicar Produtos"}
        </button>
      </div>
    </div>
  </div>
);
